import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-modal-politica-privacidad',
  templateUrl: './modal-politica-privacidad.component.html',
  styleUrls: ['./modal-politica-privacidad.component.scss']
})
export class ModalPoliticaPrivacidadComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalPoliticaPrivacidadComponent>) { }

  ngOnInit(): void {
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
